import inputPlugin from './input';
import inputNumberPlugin from './inputNumber';
import textAreaPlugin from './textArea';
import passwordPlugin from './password';
import richEditorPlugin from './richEditor';

export {
  inputPlugin,
  inputNumberPlugin,
  textAreaPlugin,
  passwordPlugin,
  richEditorPlugin
}

export default [inputPlugin, inputNumberPlugin, textAreaPlugin, passwordPlugin, richEditorPlugin]